import { render, staticRenderFns } from "./InsightFormatting.vue?vue&type=template&id=a7366e4e&scoped=true&"
import script from "./InsightFormatting.vue?vue&type=script&lang=ts&"
export * from "./InsightFormatting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7366e4e",
  null
  
)

export default component.exports